/* istanbul ignore file */
export enum RequisitionStage {
  Planning = 'Planning',
  Hiring = 'Hiring',
  Onboarding = 'Onboarding',
}

export interface IRequisition {
  requisitionID: string;
  jobTitle: string;
  dateOpened: string;
  lastUpdatedDate: string | null;
  currentStage: RequisitionStage;
  currentStep: string;
  country: string;
  state: string;
  city: string;
  numberOfPositions: number | null;
  requisitionType: string;
  remoteLocation: boolean;
  status: string;
  hiringManagerName?: string;
  recruiterName: string;
  recruiterEmail: string;
  currentOwner: {
    firstName: string;
    middleName: string;
    lastName: string;
    role: string;
  };
}

export interface IStageMetaData {
  name: RequisitionStage;
  steps: string[];
}

export interface IMyOpenRolesResponseData {
  metadata: {
    stages: IStageMetaData[];
  };
  requisitionList: IRequisition[];
}
